export const TRIP_STATUS = {
    'U': 'Upcoming',
    'O': 'Ongoing',
    'C': 'Completed',    
}